module.exports = __webpack_public_path__ + "static/media/siauliu-bankas-logo.7c9f5ea6.svg";